import { useHub } from '@/contexts/HubContext';

/**
 * Hook to check if current user is viewing in operator context
 * This checks if an operator is selected but no client is selected
 */
export function useIsOperator(): boolean {
  const { selectedOperator, selectedClient } = useHub();

  return !!(selectedOperator && !selectedClient);
}
